export default {
    unlock: 'hordeClassAssassin',
    icon: 'mdi-robber',
    baseStats: {
        attack: 8.5,
        health: 220,
        mana: 90
    },
    exp: {
        base: 2700,
        increment: 1.5
    },
    skills: {},
    skillTree: [
        {isInnate: true, level: 0, items: []},
    ],
    quests: {
        stat: [],
        zone: [],
        level: [],
        boss: []
    }
}
